import type { ApiError, ApiResult } from 'models/api';
import { UseQueryOptions, useQuery } from 'hooks/react-query';

import type { DigisignStatusResponse, LoanResponse } from '../models';

function useRGetDigisignStatus(
  options: UseQueryOptions<ApiResult<DigisignStatusResponse>, ApiError> &
    Pick<LoanResponse, 'loanXid'>,
) {
  const { loanXid, ...resOptions } = options;

  return useQuery<ApiResult<DigisignStatusResponse>, ApiError>({
    queryKey: [`loan/${loanXid}/digisign/status`],
    ...resOptions,
  });
}

export default useRGetDigisignStatus;
